


















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class NavigationBottom extends Vue {

    @Prop(Array) items!: Array <object>
    @Prop(String) active!: string
    @Prop(String) routerPath!: string

    activeState: string = this.active

    get state() {
        return this.activeState
    }

    set state(newValue) {
        this.activeState = newValue
    }
}
